export default "__VITE_ASSET__BHnq39Gi__"